module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-banner'), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.price,
      "isSecond": false,
      "slogan": "权威的指导价格",
      "description": "汇总全国重要口岸实时价格，提供行情分析，轻松判断价格走势。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.quality,
      "isSecond": true,
      "slogan": "专业的质量保障",
      "description": "布局重要木材口岸甄选优质商家，提供优质、真实的货源。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.pay,
      "isSecond": false,
      "slogan": "安全的三方支付",
      "description": "木材码头不触碰用户的资金，资金流转在第三方支付平台及银行体系内完成。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.service,
      "isSecond": true,
      "slogan": "便捷的增值服务",
      "description": "以供货、销售、仓储、物流、货检、验收、结算等环节提供专业化服务。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.info,
      "isSecond": false,
      "slogan": "广泛的资源信息",
      "description": "通过大数据整合行业资讯、库存信息、政策信息，提供精确分析。"
    }
  }), _vm._v(" "), _c('home-strength-intro', {
    attrs: {
      "imgurl": _vm.corp,
      "isSecond": true,
      "slogan": "共赢的合作理念",
      "description": "以共赢为点，打造木材产业合作、开放的综合服务平台。"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d09bb392!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/strength_intro/HomeContent.vue
// module id = 173
// module chunks = 1